
import { Carousel, CarouselItem } from 'element-ui';
import * as api from '~/api/index';
import { getNewStocksDetails } from '~/api/index';
import { GetPortfolioData } from '~/api/portfolio';
export default {
  components: {
    ElCarousel: Carousel,
    ElCarouselItem: CarouselItem,
  },
  data() {
    return {
      content: '',
      loading: false,
      postList: [],
      stockList: [],
      portfolioList: [],
      userList: [],
      liveList: [],
      historyList: [],
      hotStockList: [],
      scrollTimer: null,
      onfocus: false,
      stockInfo: null,
      portfolioInfo: null,
      searchNone: false,
      timer: null,
      shadow: false,
      hotWordList: [],
      swiperShow: true,
      swiperList: [],
      swiperValue: '',
      autoPlay: true,
      activeTimer: null,
    };
  },
  watch: {
    content() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.stockInfo = null;
        this.doSearch();
      }, 500);
      if (!this.content && this.onfocus) {
        this.getHotStock();
        this.getHistory();
        this.searchNone = true;
        this.loading = false;
      }
      if (!this.content) {
        this.swiperList = [
          ...this.hotWordList.slice(this.hotWordList.indexOf(this.swiperValue)),
          ...this.hotWordList,
        ];
      }
      this.swiperShow = this.content ? false : true;
    },
    onfocus() {
      if (!this.content && !this.loading && this.onfocus) {
        this.getHotStock();
        this.getHistory();
      }
      this.autoPlay = this.onfocus || this.swiperList.length < 2 ? false : true;
    },
    loading() {
      this.hideActiveImg();
    },
    searchNone() {
      this.hideActiveImg();
    },
  },
  mounted() {
    this.getHotSearchWord();
    document.body.addEventListener('click', this.handler);
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.handler);
  },
  methods: {
    /**
     * @description 根据搜索框宽度变化显示或隐藏导航栏广告
     */
    hideActiveImg() {
      const activeImg = document.querySelector('.activity-img');
      if (activeImg) {
        if (this.loading || this.searchNone) {
          activeImg.style.display = 'none';
        } else {
          clearTimeout(this.activeTimer);
          this.activeTimer = setTimeout(() => {
            activeImg.style.display = '';
          }, 400);
        }
      }
    },
    /**
     * @description 当前热搜词
     */
    change(e) {
      this.swiperValue = this.swiperList[e];
    },
    scrollHandle() {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        const resultBox = document.querySelector('.search-result');
        if (
          resultBox.scrollTop + resultBox.clientHeight <
          resultBox.scrollHeight
        ) {
          this.shadow = true;
        } else {
          this.shadow = false;
        }
      }, 100);
    },
    showResult() {
      if (!this.content) {
        this.searchNone = true;
        return;
      }
      this.loading = true;
      this.searchNone = false;
    },
    /**
     * @description 点击跳转
     */
    jumpSearch() {
      this.content = this.content || this.swiperValue;
      if (!this.content) return;
      this.setHistory();
      this.$router.push(`/search?keyword=${this.content}&type=post`);
      this.loading = false;
      this.searchNone = false;
      this.onfocus = false;
      // window.open("/search/post/" + this.content);
    },
    /**
     * @description 搜索
     */
    doSearch() {
      if (!this.content) return;
      this.$axios(
        api.doIndexSearch({
          keyword: this.content,
          page: 1,
          count: 3,
        })
      ).then(res => {
        if (this.onfocus) {
          this.loading = true;
          this.searchNone = false;
        }
        this.postList = res.result.searchPost?.list || [];
        this.liveList = res.result.searchLive?.list || [];
        this.stockList = res.result?.searchStock?.list || [];
        this.userList = res.result.searchUser?.list || [];
        this.portfolioList = res.result.searchPortfolio?.list || [];
        const stockArr = [];
        this.stockList &&
          this.stockList.forEach(item => {
            const stockCode = `${item.type.toLowerCase()}${item.stockCode}`;
            if (!stockArr.includes(stockCode)) {
              stockArr.push(stockCode);
            }
          });
        this.getstocksInfo(stockArr);
        this.$nextTick(() => {
          if (document.querySelector('.search-result').scrollHeight < 471) {
            this.shadow = false;
          } else {
            this.shadow = true;
          }
        });
        this.getPortfolioInfo(this.portfolioList);
      });
      // this.getLiveInfo();
    },
    /**
     * @description 获取热搜词
     */
    async getHotSearchWord() {
      const res = await this.$axios(api.getHotSearchWord());
      if (res.result) {
        this.hotWordList = [...res.result.trendingSearchKeywords.split(',')];
        this.swiperList = [...this.hotWordList, ...this.hotWordList];
        this.swiperValue = this.hotWordList[0];
      }
      if (this.hotWordList.length === 1) {
        this.autoPlay = false;
      }
      if (!this.hotWordList.length) {
        this.swiperShow = false;
      }
    },
    /**
     * 获取快讯信息
     */
    async getLiveInfo() {
      const res = await this.$axios(
        api.searchSolrLive({
          keyword: this.content,
          page: 1,
          count: 3,
        })
      );
      this.liveList = res.result;
    },
    /**
     * @description 获取热门股票
     */
    async getHotStock() {
      const stockArr = [];
      const data = await this.$axios(api.getHotStock());
      this.hotStockList = data.result ? data.result.stock : [];
      this.hotStockList.forEach(item => {
        const stockCode = `${item.market.toLowerCase()}${item.code}`;
        if (!stockArr.includes(stockCode)) {
          stockArr.push(stockCode);
        }
      });
      this.getstocksInfo(stockArr);
    },
    /**
     * @description 从浏览器缓存获取搜索历史
     */
    getHistory() {
      const historyArr = localStorage.getItem('g_web_search_history');
      this.historyList = historyArr ? JSON.parse(historyArr) : [];
      this.searchNone = true;
    },
    /**
     * @description 设置搜索历史到浏览器缓存
     */
    setHistory() {
      const index = this.historyList.indexOf(this.content);
      if (index === 0) return;
      if (index !== -1) {
        this.historyList.splice(index, 1);
      }
      if (!this.historyList.includes(this.content)) {
        this.historyList.unshift(this.content);
        if (this.historyList.length > 20) {
          this.historyList.splice(20);
        }
        localStorage.setItem(
          'g_web_search_history',
          JSON.stringify(this.historyList)
        );
      }
    },
    /**
     * @description 点击某条搜索历史的处理
     */
    clickHistory(e) {
      this.content = e.target.innerText;
      this.searchNone = false;
      this.jumpSearch();
    },
    /**
     * @description 清空单条搜索历史
     */
    clearHistory(e) {
      const index = this.historyList.indexOf(
        e.target.previousElementSibling.innerText
      );
      if (index !== -1) {
        this.historyList.splice(index, 1);
        localStorage.setItem(
          'g_web_search_history',
          JSON.stringify(this.historyList)
        );
      }
    },
    /**
     * @description 清空全部搜索历史
     */
    clearAllHistory() {
      this.historyList = [];
      localStorage.setItem('g_web_search_history', []);
    },
    /**
     * @description 获取股票详情信息
     */
    async getstocksInfo(stockArr) {
      if (!stockArr) return;
      const stockInfo = {};
      const data = await this.$axios(
        getNewStocksDetails({
          stockCodes: stockArr.join(','),
        })
      );
      data.result &&
        data.result.forEach(item => {
          const stockcode = `${item.market.toLowerCase()}${item.code}`;
          stockInfo[stockcode] = {
            name: item.name,
            netChange: item.netChange,
            price: item.price,
            codeDesc: stockcode.replace(/12/g, `<hl>${this.content}</hl>`),
          };
        });
      this.stockInfo = stockInfo;
    },
    async getPortfolioInfo(list = []) {
      if (!list.length) return;
      const portfolioInfo = {};
      for (let i = 0; i < list.length; i++) {
        const code = list[i].portfolioCode;
        const res = await this.$axios(GetPortfolioData(code));
        if (res.result) {
          portfolioInfo[code] = {
            netValue: res.result.netValue,
            dayProfit: res.result.dayProfit,
          };
        }
      }
      this.portfolioInfo = portfolioInfo;
    },
    /**
     * @description 监听函数
     */
    handler(e) {
      if (
        this.$refs &&
        this.$refs.searchPopup &&
        !this.$refs.searchPopup.contains(e.target)
      ) {
        this.loading = false;
        this.searchNone = false;
        clearTimeout(this.activeTimer);
        this.activeTimer = setTimeout(() => {
          const activeImg = document.querySelector('.activity-img');
          if (activeImg && !this.loading && !this.searchNone) {
            activeImg.style.display = '';
          }
        }, 200);
      }
    },
  },
};
